import { create } from 'zustand';

import { shallowInitState } from '../constants/index.js';

export const createStore = () => {
  return create(() => shallowInitState);
};
